import React, { useState } from "react";

const items = [
  "HDEUI",
  "HDEUII",
  "HDEUIII",
  "HDEUIV",
  "HDEUV",
  "HDEUVI",
  "HDEUVII",
  "HDSEI",
  "HDSEII",
  "HDSEIII",
  "LFEUI",
  "LFEUII",
  "LFEUIII",
  "LFEUIV",
  "LFEUV",
  "LFEUVI",
  "MDEUI",
  "MDEUII",
  "MDEUIII",
  "MDEUIV",
  "MDEUV",
  "MDEUVI",
  "MDEUVII",
  "MDEUVIp",
  "MOT4I",
  "MOT4II",
  "MOT4III",
  "NSC_TRA",
];

export default function Vehicle(props) {
  const [Seleted, setSeleted] = useState([]);
  const handleSelect = (item) => {
    if (Seleted.includes(item)) {
      setSeleted(Seleted.filter((i) => i !== item));
      props.onSelect(Seleted.filter((i) => i !== item));
    } else {
      setSeleted([...Seleted, item]);
      props.onSelect([...Seleted, item]);
    }
  };

  return (
    <div className="flex justify-center items-center flex-col">
      <h1 className="pb-3 text-2xl font-bold">Choose vehicle types !!</h1>
      <div className="grid grid-cols-7 gap-8">
        {items.map((item, index) => (
          <div
            key={index}
            className={`w-24 h-16 rounded-2xl shadow-lg flex items-center justify-center cursor-pointer transform transition-transform hover:scale-125 hover:rotate-6 text-white font-bold ${
              Seleted.includes(item)
                ? `bg-gain scale-125 rotate-0`
                : `bg-primary`
            }`}
            onClick={() => {
              handleSelect(item);
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}
